module.exports = __webpack_public_path__ + "img/s1_t1_29.b8372dc9.jpeg";